<template>
  <card class="card" title="Upload TIDs & Terminals">
    <form @submit.prevent>
      <h4>Upload Bulk TIDs</h4>
      <div class="col-md-6">
        <label
          >Upload CSV File<span class="required" v-if="!bulkFile"
            >*</span
          ></label
        >
        <input
          type="file"
          class="form-control"
          accept=".csv"
          @change="bulkFileChange"
          ref="bulkFileInput"
        />
      </div>
      <div class="text-center">
        <p-button
          type="info"
          round
          @click.native.prevent="submitBulk"
          :disabled="!bulkFile || loading.show"
        >
          <div
            class="spinner-grow"
            role="status"
            v-if="loading.show === true"
          ></div>
          Submit Bulk Upload
        </p-button>
      </div>
    </form>

    <div>
      <form @submit.prevent>
        <h4>Upload Terminal for Single Merchant</h4>
        <div class="row">
          <div class="col-md-6">
            <label
              >Select a Merchant<span class="required" v-if="!selectedMerchant"
                >*</span
              >
              <span class="required-field" v-if="!selectedMerchant"
                >[required field]</span
              ></label
            >
            <multiselect
              v-model="selectedMerchant"
              :custom-label="optionLabel"
              track-by="_id"
              :options="utils.merchants"
              :allow-empty="false"
              placeholder="Select a Merchant"
              @close="getAgents"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.merchantName }}
              </template>
            </multiselect>
            <span class="required-text" v-if="!selectedMerchant"
              >Please select a merchant.</span
            >
          </div>

          <div class="col-md-6">
            <label>Select Agent</label>
            <multiselect
              v-model="selectedAgent"
              :custom-label="optionLabel2"
              track-by="_id"
              :options="auth.agents"
              :allow-empty="false"
              placeholder="Select an Agent"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.firstName }}
              </template>
            </multiselect>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label
              >Add File<span class="required" v-if="!file">*</span
              ><span class="required-field" v-if="!file"
                >[required field]</span
              ></label
            >
            <div>
              <input
                type="file"
                class="form-control"
                accept=".csv"
                :file="this.file"
                @change="fileChange"
              />
            </div>
            <span class="required-text" v-if="!file">Please add a file.</span>
          </div>
        </div>

        <div class="text-center">
          <p-button type="info" round @click.native.prevent="submit">
            <div
              class="spinner-grow"
              role="status"
              v-if="loading.show === true"
            ></div>
            Upload Terminal
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import axios from "../store/axios";
import { mapState, mapActions } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      file: "",
      bulkFile: "",
      selectedMerchant: "",
      selectedAgent: "",
      loadingLocal: false,
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  methods: {
    ...mapActions([
      "uploadTerminal",
      "getMerchants",
      "getStates",
      "getLgas",
      "getCountries",
      "getAllMerchantAgents",
      "setNotification",
    ]),

    async submitBulk() {
      const formData = new FormData();
      formData.append("csvFile", this.bulkFile);
      this.loadingLocal = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/tid/upload`,
          formData,
        );
        this.setNotification({
          message: res.data.message,
          type: "success",
        });
        this.bulkFile = "";
        if (this.$refs.bulkFileInput) {
          this.$refs.bulkFileInput.value = "";
        }
      } catch (error) {
        console.error(error);
        this.setNotification({
          message: "Error uploading file, try again",
          type: "danger",
        });
      } finally {
        this.loadingLocal = false;
        this.bulkFile = "";
      }
    },

    submit() {
      const formData = new FormData();
      formData.append("csvFile", this.file);
      if (this.selectedMerchant !== "") {
        formData.append("tmsMerchantId", this.selectedMerchant._id);
      }
      if (this.selectedAgent !== "") {
        formData.append("tmsAgentId", this.selectedAgent._id);
      }
      this.uploadTerminal(formData);
    },
    optionLabel({ merchantName, state, country }) {
      return `${merchantName}, ${state}, ${country}`;
    },
    optionLabel2({ firstName, lastName, agentId }) {
      return `${firstName}, ${lastName}, ${agentId}`;
    },
    fetchLgas() {
      this.terminal.lga = "";
      this.getLgas(this.terminal.state);
    },
    getAgents() {
      // console.log(this.selectedMerchant)
      this.getAllMerchantAgents({ merchantId: this.selectedMerchant._id });
    },
    fileChange(e) {
      const file = e.target.files[0];
      this.file = file;
    },
    bulkFileChange(e) {
      this.bulkFile = e.target.files[0] || "";
    },
  },
  mounted() {
    this.getMerchants();
    this.getCountries();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.required {
  color: red;
  margin-left: 2px;
}

.required-field {
  font-size: 0.8rem;
  color: #888;
  margin-left: 5px;
}
</style>
